// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCuZSfoPCMGfMVa9Iaz3raUQT_ajR363cs",
  authDomain: "crypto-tracker-b2d12.firebaseapp.com",
  projectId: "crypto-tracker-b2d12",
  storageBucket: "crypto-tracker-b2d12.appspot.com",
  messagingSenderId: "206233316122",
  appId: "1:206233316122:web:e0749641d1f623f71d5aa3"
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig);

export default firebaseConfig